export const mainImmobilization = {
    title: "Immobilisation",
    loading: "Chargement de l'immobilisation'",
    cancel: {
        label: "perdre vos modifications",
        title: "Annulation",
        content: "Vous êtes sur le point d'annuler l'ensemble de vos modifications. Vous confirmez ?"
    },
    create: "L'immobilisation {number} a bien été sauvegardée."
}